import axiosClient from '../axiosClient';

export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axiosClient.post('/media/upload', formData, { timeout: 300000 });
};
